import { render, staticRenderFns } from "./BottomIcon.vue?vue&type=template&id=8b948772&scoped=true&"
import script from "./BottomIcon.vue?vue&type=script&lang=js&"
export * from "./BottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b948772",
  null
  
)

export default component.exports